module.exports = __webpack_public_path__ + "static/media/eth.bca90c0a.svg";